export default __webpack_public_path__ + "static/media/wcag_logo.393b6f57.png";